import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TicketToMoneyPipe} from "../../../../shared/pipes/ticket-to-money.pipe";
import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {ImageWrapperComponent} from "../../../../shared/components/image-wrapper/image-wrapper.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-product-item-card',
  standalone: true,
    imports: [
        TicketToMoneyPipe,
        RouterLink,
        TranslateModule,
        ImageWrapperComponent,
        NgIf
    ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './product-item-card.component.html',
  styleUrl: './product-item-card.component.scss'
})
export class ProductItemCardComponent {
  @Input() product: any;
}
